module.exports = __webpack_public_path__ + "img/bule2.f014110f.png";